/**
 * Encodes an `ArrayBuffer` / typed array as lowercase hex.
 */
export function bufferToHex(buffer: ArrayBuffer | ArrayBufferView): string {
  const bytes =
    buffer instanceof ArrayBuffer
      ? new Uint8Array(buffer)
      : new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);

  return [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
}
